// Public API exports for @mutagent/cli
export { loadConfig, saveCredentials, clearCredentials } from './lib/config.js';
export { getSDKClient, validateApiKey } from './lib/sdk-client.js';
export { OutputFormatter } from './lib/output.js';
export { MutagentError, AuthenticationError, ApiError } from './lib/errors.js';
export type {
  Config,
  Prompt,
  Dataset,
  Evaluation,
  OptimizationJob,
  Trace,
  FrameworkIntegration,
  IntegrationConfig,
} from './types/index.js';

// Version
export const version = '0.1.0';
